import { render } from "./sendMessages.vue?vue&type=template&id=4acc7af8&scoped=true"
import script from "./sendMessages.vue?vue&type=script&lang=js"
export * from "./sendMessages.vue?vue&type=script&lang=js"

import "./sendMessages.vue?vue&type=style&index=0&id=4acc7af8&scoped=true&lang=css"

import exportComponent from "/var/www/html/garbage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4acc7af8"]])

export default __exports__